var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.shopObj)?_c('p',{staticClass:"section-title"},[_vm._v("Account")]):_vm._e(),(_vm.routeReady)?_c('router-view'):_c('Loading')],1)}
var staticRenderFns = []

export { render, staticRenderFns }